import { Fancybox } from '@fancyapps/ui';
import domReady from '@wordpress/dom-ready';

domReady(() => {
  Fancybox.bind('[data-fancybox]', {});
});
